if (!customElements.get('fb-bundle-placement')) {
  customElements.define('fb-bundle-placement', class extends HTMLElement {
    connectedCallback() {
      const section = this.closest('.fb-product-page');
      if (!section) return;
      const positionBundle = () => {
        const widget = section.querySelector('.cbb-frequently-bought-container');
        if (!widget) return false;
        if (widget.parentElement !== this) this.prepend(widget);
        const note = this.querySelector('.fb-bundle-note');
        if (note) note.hidden = !/dünger|fertili[sz]er/i.test(widget.textContent) || !/\bPRO\b|NPK/i.test(widget.textContent);
        this.observer?.disconnect();
        clearTimeout(this.expiry);
        return true;
      };
      if (positionBundle()) return;
      this.observer = new MutationObserver(positionBundle);
      this.observer.observe(section, {childList: true, subtree: true});
      this.expiry = setTimeout(() => this.observer?.disconnect(), 30000);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      clearTimeout(this.expiry);
    }
  });
}
if (!customElements.get('fb-care-pair')) {
  customElements.define('fb-care-pair', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.selectors = [...this.querySelectorAll('[data-care-variant]')];
      this.cards = [...this.querySelectorAll('[data-care-card]')];
      this.toggles = [...this.querySelectorAll('[data-care-toggle]')];
      this.cases = JSON.parse(this.querySelector('[data-care-cases]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-care-labels]').textContent);
      this.button = this.querySelector('[type=submit]');
      this.error = this.querySelector('.fb-care-error');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style: 'currency', currency: this.dataset.currency || 'EUR'});
      this.onChange = event => {
        if (event.target.matches('[data-care-variant][data-care-index="0"]')) this.syncMainVariant();
        this.updateSelection();
      };
      this.onSubmit = event => this.addSelection(event);
      this.form.addEventListener('change', this.onChange);
      this.form.addEventListener('submit', this.onSubmit);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          if (event.data.sectionId !== this.dataset.sectionId || !event.data.variant) return;
          const input = this.selectors[0];
          if (input.tagName === 'SELECT') input.value = String(event.data.variant.id);
          this.updateSelection();
        });
      }
      this.updateSelection();
    }
    disconnectedCallback() {
      this.form?.removeEventListener('change', this.onChange);
      this.form?.removeEventListener('submit', this.onSubmit);
      this.unsubscribe?.();
    }
    selectedData(input, index) {
      const option = input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
      const toggle = this.cards[index].querySelector('[data-care-toggle]');
      return {id: String(input.value), price: Number(option?.dataset.price || 0), selected: index === 0 || !!toggle?.checked, available: option?.dataset.available === 'true', unitPrice: option?.dataset.unitPrice === '' ? null : Number(option?.dataset.unitPrice), unitReference: option?.dataset.unitReference || '', image: option?.dataset.image || ''};
    }
    syncMainVariant() {
      const input = this.selectors[0];
      if (input.tagName !== 'SELECT') return;
      const title = input.selectedOptions[0]?.textContent.trim();
      const section = this.closest('.fb-product-page');
      const picker = section?.querySelector('variant-radios,variant-selects');
      if (!picker || !title) return;
      const radio = [...picker.querySelectorAll('input[type="radio"]')].find(item => item.value === title);
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', {bubbles: true}));
        return;
      }
      const select = picker.querySelector('select');
      if (!radio && select && [...select.options].some(option => option.value === title) && select.value !== title) {
        select.value = title;
        select.dispatchEvent(new Event('change', {bubbles: true}));
      }
    }
    updateSelection() {
      if (this.busy) return;
      const all = this.selectors.map((input, index) => this.selectedData(input, index));
      all.forEach((item, index) => {
        const card = this.cards[index];
        card.querySelector('[data-care-price]').textContent = this.money.format(item.price / 100);
        const unit = card.querySelector('[data-care-unit-price]');
        unit.hidden = item.unitPrice === null || !Number.isFinite(item.unitPrice) || !item.unitReference;
        unit.textContent = unit.hidden ? '' : this.money.format(item.unitPrice / 100) + ' / ' + item.unitReference;
        const image = card.querySelector('.fb-care-photo img');
        if (image && item.image && image.getAttribute('src') !== item.image) {
          image.removeAttribute('srcset');
          image.src = item.image;
        }
        card.classList.toggle('fb-care-card--selected', item.selected);
      });
      const selected = all.filter(item => item.selected);
      const combined = selected.length > 1;
      const regular = selected.reduce((sum, item) => sum + item.price, 0);
      const expected = combined ? Math.round(regular * 90 / 100) : regular;
      const key = selected.map(item => item.id).sort().join('|');
      const bundle = combined ? this.cases.find(item => item.key === key) : null;
      const priceMatches = !combined || !bundle?.available || bundle.price === expected;
      const ready = !combined || !!bundle?.available;
      const eligible = selected.every(item => item.id && item.available);
      this.selection = {selected, combined, bundle, expected};
      this.querySelector('[data-care-retail]').textContent = this.money.format(regular / 100);
      this.querySelector('[data-care-total]').textContent = this.money.format(expected / 100);
      this.querySelector('[data-care-total-label]').textContent = combined ? this.labels.comboPrice : this.labels.onlyMainPrice;
      const saving = this.querySelector('[data-care-saving]');
      saving.hidden = !combined;
      saving.textContent = this.labels.saving.replace('[amount]', this.money.format((regular - expected) / 100));
      const hint = this.querySelector('[data-care-hint]');
      hint.textContent = !combined ? this.labels.selectHint : !priceMatches ? this.labels.priceChanged : !ready ? this.labels.pending : this.labels.readyHint;
      this.button.disabled = !eligible || !ready || !priceMatches;
      this.button.textContent = !eligible ? this.labels.unavailable : combined && !ready ? this.labels.pending : combined ? this.labels.addCombo : this.labels.addMain;
    }
    async addSelection(event) {
      event.preventDefault();
      if (this.busy || this.button.disabled) return;
      this.updateSelection();
      if (this.button.disabled) return;
      const {selected, combined, bundle} = this.selection;
      const id = combined ? bundle?.id : selected[0]?.id;
      if (!id) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.labels.adding;
      this.setAttribute('aria-busy', 'true');
      this.error.hidden = true;
      const controls = [...this.form.querySelectorAll('input,select')].map(input => ({input, disabled: input.disabled}));
      controls.forEach(({input}) => {input.disabled = true;});
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [{id: Number(id), quantity: 1}]})});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || this.labels.error);
        window.location.assign(window.routes?.cart_url || root + 'cart');
      } catch (error) {
        this.error.textContent = error.message || this.labels.error;
        this.error.hidden = false;
        this.busy = false;
        controls.forEach(({input, disabled}) => {input.disabled = disabled;});
        this.removeAttribute('aria-busy');
        this.updateSelection();
      }
    }
  });
}
